<div class="form-group">
  <label for="">{{appName}} *</label>
  <div class="form-check">
    <input
      class="form-check-input"
      type="radio"
      [name]="appName"
      [id]="appName + '-yes'"
      [value]="true"
      [(ngModel)]="isAppChecked"
      (change)="changeRadioVal()"
    />
    <label class="form-check-label" [for]="appName + '-yes'"> {{"Sì" | translate}} </label>
  </div>
  <div class="form-check">
    <input
      class="form-check-input"
      type="radio"
      [name]="appName"
      [id]="appName + '-no'"
      [value]="false"
      [(ngModel)]="isAppChecked"
      (change)="changeRadioVal()"
    />
    <label class="form-check-label" [for]="appName + '-no'"> {{"No" | translate}} </label>
  </div>
</div>
